import { cn } from "@layer/utils/cn";
import type { ReactElement } from "react";
import { SidebarTrigger } from "../../../components/sidebar";
import { NavBreadcrumbs } from "./nav-breadcrumbs";

// TODO: The Switch component will determine the state of whether the system is in test more or in production
// The state of this switch will affect every Query, Mutation etc, so there
// is probably some manipulation of the API_URL (which doesn't exist yet) that will have to change based on the state of this switch
// WILL really have to think about how this plays with Server side data fetching

type NavbarProps = {
	tabKey: string;
	components?: ReactElement[];
	isMinimalShell?: boolean;
	alwaysCollapsed?: boolean;
};

export const Navbar = ({
	tabKey,
	components,
	isMinimalShell,
	alwaysCollapsed,
}: NavbarProps) => {
	return (
		<div className="pt-4 pr-4 pl-3">
			<div
				className={cn(
					"nav-panel-style h-12 px-3 flex items-center justify-between",
				)}
			>
				<div className="flex items-center gap-4">
					{!isMinimalShell && !alwaysCollapsed && <SidebarTrigger />}
					<NavBreadcrumbs tabKey={tabKey} />
				</div>
				<div className="flex items-center gap-x-4">
					{components?.map((c) => c)}
				</div>
			</div>
		</div>
	);
};
